import gql from 'graphql-tag';

export const GET_PARTNER_LINKS_OPTIONS = gql`
  query PartnerLinksOptions($dynamicsId: ID!) {
    options: getPartnerLinks(dynamicsId: $dynamicsId) {
      dynamicsPartnerAccountId
      value: vendorProfileId
      label: accountName
    }
  }
`;
